import type { Locale } from "@/lib/i18n";
import { pl, type CContactFormTranslations } from "./pl";
import { en } from "./en";
import { de } from "./de";

export const cContactFormTranslations: Record<Locale, CContactFormTranslations> = {
  pl,
  en,
  de,
};

export type { CContactFormTranslations };
